import { z } from 'zod';

import { israeliIdSchema, numericSchema } from 'features/onboarding/schemas/primitives';

export const bankAccountSchema = z.object({
  bankName: z.string().min(1, 'required'),
  bankBranchNumber: numericSchema(1),
  bankAccountNumber: numericSchema(1),
  bankAccountOwnerName: z.string().min(1, 'required'),
  bankAccountOwnerId: israeliIdSchema,
});

export type BankAccountInput = z.infer<typeof bankAccountSchema>;
